import type { UploadTransportResult } from '@/adapters/fileTransfer/types';

const putFile = async (
  uploadUrl: string,
  headers: Record<string, string>,
  fileUri: string,
): Promise<UploadTransportResult> => {
  const source = await fetch(fileUri);
  const body = await source.blob();
  const response = await fetch(uploadUrl, { method: 'PUT', headers, body });

  return { status: response.status, body: await response.text() };
};

export { putFile };
